import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=5ebdfc22&scoped=true&"
import script from "./CardLink.vue?vue&type=script&lang=js&"
export * from "./CardLink.vue?vue&type=script&lang=js&"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=5ebdfc22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebdfc22",
  null
  
)

export default component.exports